import { render, staticRenderFns } from "./DisciplinedDriver.vue?vue&type=template&id=873fa188"
import script from "./DisciplinedDriver.vue?vue&type=script&lang=ts"
export * from "./DisciplinedDriver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports